import { ClinicForm } from './clinic-form';

export class ServiceTemplateForm {
  public id: number;
  public clinicServiceTemplateId: number;
  public clinicFormId: number;
  public clinicForm: ClinicForm;
  public isSelectedByDefault: boolean = true;

  public static fromForm(clinicServiceTemplateId: number, form: ClinicForm) {
    let serviceForm = new ServiceTemplateForm();
    serviceForm.clinicServiceTemplateId = clinicServiceTemplateId;
    serviceForm.clinicFormId = form.id;
    serviceForm.clinicForm = form;
    return serviceForm;
  }

  public constructor(init?: Partial<ServiceTemplateForm>) {
    Object.assign(this, init);
  }
}
